import { FlowchartLinkAttributeOperator } from '@treetop/shared/model';

export enum BoolValue {
  true = 'Yes',
  false = 'No',
}

export class LinkAttributeConverter {
  static convertOperatorToValue(operator: FlowchartLinkAttributeOperator): string {
    switch (operator) {
      case FlowchartLinkAttributeOperator.Equals:
        return '=';
      case FlowchartLinkAttributeOperator.SmallerThan:
        return '<';
      case FlowchartLinkAttributeOperator.SmallerThanOrEquals:
        return '<=';
      case FlowchartLinkAttributeOperator.BiggerThanOrEquals:
        return '>=';
      case FlowchartLinkAttributeOperator.BiggerThan:
        return '>';
      case FlowchartLinkAttributeOperator.Includes:
        return 'Includes';
      case FlowchartLinkAttributeOperator.Between:
        return 'Between';
      default:
        return '=';
    }
  }

  static convertValueToOperator(value: string): FlowchartLinkAttributeOperator {
    switch (value) {
      case '=':
        return FlowchartLinkAttributeOperator.Equals;
      case '<':
        return FlowchartLinkAttributeOperator.SmallerThan;
      case '<=':
        return FlowchartLinkAttributeOperator.SmallerThanOrEquals;
      case '>=':
        return FlowchartLinkAttributeOperator.BiggerThanOrEquals;
      case '>':
        return FlowchartLinkAttributeOperator.BiggerThan;
      case 'Includes':
        return FlowchartLinkAttributeOperator.Includes;
      case 'Between':
        return FlowchartLinkAttributeOperator.Between;
    }
  }
}
